import React, { useState, useEffect } from 'react';
import { Button, Col, Container, FormGroup, Input, Row } from 'reactstrap';
import TableService from '../../../Services/QRCodeServices/TableSerivce/TableService';
import toast from 'react-hot-toast';
import { AddTable } from '../table/AddTable';
import { TableCard } from '../table/TableCard';
import { OrderDetailsModal } from '../table/OrderDetailsModal';

export const OrgTable = () => {
    const [tables, setTables] = useState([]);
    const [activeTableDetails, setActiveTableDetails] = useState(null);
    const [selectedTable, setSelectedTable] = useState(null);
    const [showOrderModal, setShowOrderModal] = useState(false);
    const [modal, setModal] = useState(false);
    const [tableName, setTableName] = useState('');
    const [tableDescription, setTableDescription] = useState('');
    const [loading, setLoading] = useState(false);  
    const [isOccupiedFilter, setIsOccupiedFilter] = useState('all');
    const [isActiveFilter, setIsActiveFilter] = useState('all');
  
    useEffect(() => {
      fetchTables();
    }, []);
  
    // Fetch all tables for display
    const fetchTables = async () => {
      try {
        const data = await TableService.getList();
        setTables(data);
      } catch (error) {
        console.error('Error fetching tables:', error);
        toast.error('Failed to fetch tables');
      }
    };

    // Fetch active table details when an occupied table is clicked
    const fetchActiveTableDetails = async (tableId) => {
      try {
        const activeData = await TableService.getActiveTableList();
        const tableDetails = activeData.find(table => table.id === tableId);
        if (tableDetails) {
          setActiveTableDetails(tableDetails);
          setShowOrderModal(true);
        } else {
          toast.error('No active order found for this table');
        }
      } catch (error) {
        console.error('Error fetching active table details:', error);
        toast.error('Failed to fetch table details');
      }
    };
  
    const toggleModal = () => setModal(!modal);

    const handleTableClick = (table) => {
      if (table.isOccupied) {
        setSelectedTable(table);
        fetchActiveTableDetails(table.id);
      }
    };
  
    const handleCreateTable = async () => {
      setLoading(true);
      if (!tableName || !tableDescription) return;
      try {
        await TableService.create({
          identification: tableName,
          description: tableDescription,
        });
        fetchTables();
        toggleModal();
        toast.success("Table created successfully");
        setTableName('');
        setTableDescription('');
        setLoading(false);
      } catch (error) {
        console.error('Error creating table:', error);
        toast.error("Failed to create table");
        setLoading(false);
      }
    };

    const filteredTables = tables.filter((table) => {
      return (
        (isOccupiedFilter === 'all' || table.isOccupied.toString() === isOccupiedFilter) &&
        (isActiveFilter === 'all' || table.isActive.toString() === isActiveFilter)
      );
    });
  
    return (
      <Container fluid className="p-4">
        <Row className="mb-4 text-end">
          <Col md={5}>
          </Col>
          <Col md={2}>
            <FormGroup>
              <Input
                type="select"
                id="isOccupiedFilter"
                value={isOccupiedFilter}
                onChange={(e) => setIsOccupiedFilter(e.target.value)}
              >
                <option value="all">All</option>
                <option value="true">Occupied</option>
                <option value="false">Not Occupied</option>
              </Input>
            </FormGroup>
          </Col>

          <Col md={2}>
            <FormGroup>
              <Input
                type="select"
                id="isActiveFilter"
                value={isActiveFilter}
                onChange={(e) => setIsActiveFilter(e.target.value)}
              >
                <option value="all">All</option>
                <option value="true">Active</option>
                <option value="false">Inactive</option>
              </Input>
            </FormGroup>
          </Col>
          <Col md={3}>
            <Button color="primary" onClick={toggleModal}>
              Add New Table
            </Button>
          </Col>
        </Row>
  
        <Row>
          {filteredTables.map((table) => (
            <Col key={table.id} lg={2} md={6} sm={6} xs={6} className="mb-4">
              <TableCard 
                table={table} 
                onClick={() => handleTableClick(table)}
              />
            </Col>
          ))}
        </Row>
  
        <AddTable
          isOpen={modal}
          toggle={toggleModal}
          tableName={tableName}
          setTableName={setTableName}
          tableDescription={tableDescription}
          setTableDescription={setTableDescription}
          handleCreateTable={handleCreateTable}
        />

        {activeTableDetails && (
          <OrderDetailsModal
            isOpen={showOrderModal}
            toggle={() => {
              setShowOrderModal(false);
              setActiveTableDetails(null);
            }}
            orderDetails={activeTableDetails.menuOrder}
          />
        )}
      </Container>
    );
};